import classNames from 'classnames';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { successNotification } from '../../helpers/notification';
import styles from './index.module.scss';

interface NavLinkWithCopyTextProps {
  text: string | number;
  path: string;
  onCopy?: () => void;
  withWordBreak?: boolean;
}

export const NavLinkWithCopyText: FC<NavLinkWithCopyTextProps> = ({
  path,
  text,
  withWordBreak,
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(`${text}`);
    successNotification('Text has been copied');
  };

  return (
    <div className={styles.navLinkWithCopyText}>
      <NavLink className={classNames({ 'word-break': withWordBreak })} to={path}>
        {text}
      </NavLink>
      <span className={styles.copyIcon} onClick={handleCopy} title='Copy text'>
        <i className='fas fa-copy' aria-hidden='true'></i>
      </span>
    </div>
  );
};
